module.exports = __webpack_public_path__ + "assets/img/data_base.80033ba0.png";